import { jsx as _jsx } from "react/jsx-runtime";
import AdminPageLayout from '../../../layout/admin-page-layout';
import { DiscussionList } from '../../_shared/discussions';
import { adminRoutes } from '../../../common/routes/admin';
function AdminDiscussions() {
    return (_jsx(AdminPageLayout, { children: _jsx(DiscussionList, { routes: {
                listPath: adminRoutes.discussions.getURL(),
                newPath: adminRoutes.discussionsNew.getURL(),
                detailPath: (id) => adminRoutes.discussionsDetail.getURL({ id }),
            }, title: "Discussions", subtitle: "Collaborate with your team on administrative issues that matter" }) }));
}
export default AdminDiscussions;
